import React, { useEffect } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useDispatch, useSelector } from 'react-redux';
import { getSuperAdminStatsAPI } from '../../redux/slices/dashboardStatsSlice';

const SuperAdminDashboard = () => {

    const dispatch = useDispatch();
    const superAdminStats = useSelector((state) => state?.dashboardStatsSlice?.superAdminStats);

    const fetchCorporates = async () => {
        try {
            await dispatch(getSuperAdminStatsAPI());
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCorporates();
    }, []);

    return (
        <>
            <AdminDashboardLayout>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="dashboard-cards">
                                <i className="fa-brands fa-slack"></i>
                                <h3>Number of companies</h3>
                                <h1>{superAdminStats?.total_corporates}</h1>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="dashboard-cards">
                                <i className="fa-brands fa-slack"></i>
                                <h3>Number of Employees</h3>
                                <h1>{superAdminStats?.total_employees}</h1>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="dashboard-cards">
                                <i className="fa-solid fa-user-tie"></i>
                                <h3>Number of professionals</h3>
                                <h1>{superAdminStats?.total_professionals}</h1>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="dashboard-cards">
                                <i className="fa-solid fa-users"></i>
                                <h3>Number of users</h3>
                                <h1>{superAdminStats?.total_users}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminDashboardLayout>
        </>
    )
}

export default SuperAdminDashboard